<!-- 水泥路面预防性养护初选库-->
<template>
  <d2-container>
    <div v-show="!showTabFom">
      <el-row style="margin-bottom: 20px">
        <el-col :span="4">
          <popover-form popoverWidth="680" :formConfig="advSearch" v-model="searchForm" @onSubmit="searchTable"></popover-form>
        </el-col>
        <el-col :span="20">
            <div class="text-align_right">
                <el-button type="primary" @click="addRow">新增</el-button>
            </div>
        </el-col>
      </el-row>
      <div>
        <dynamic-table
          :tableSet="tableSet"
          :tableData="tableData"
          :pageIndex="pageIndex"
          :pageShow="false"
          :pageShowX = "true"
          @goPageIndex="goPageIndex"
          :pageCount="pageCount"
          @rowClick="rowClick($event)"
        ></dynamic-table>
      </div>
    </div>
    <div v-show="showTabFom">
      <div>
        <div>
          <div class="text-align_right">
              <el-button-group>
                <el-button type="primary" v-if="(operationType==1||operationType==2)" @click="dataSubmit" >保存</el-button>
                <el-button type="primary" @click="close">返回</el-button>
              </el-button-group>
          </div>
          <divider title="水泥路面预防性养护初选库明细" />
          <dynamic-form ref="form" :formConfig="formConfig" :disabled="!(operationType==1||operationType==2)" v-model="form"></dynamic-form>
        </div>
      </div>
    </div>
    <template slot="footer" v-if="showTabFom">
      <billing-info :billingInfo="form"></billing-info>
    </template>
  </d2-container>
</template>
<script>
export default {
  name: "cxCementmeasures",
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    return {
      initializeForm:{},
      showTabFom: false, //表格表单转换状态
      operationType: 1, //主表操作状态

      searchForm: {
        measure :'',/// 适用养护措施
        highwayLevel :'',/// 适用公路等级
      },
      advSearch: {
        list: [
          {
            "type": "select",
            "icon": "icon-select",
            "options": {
              "defaultValue": "","multiple": false,"disabled": false,"clearable": false,"placeholder": "请选择","required": false,"showLabel": false,"width": "250px","options": [],"remote": true,"remoteType": "option",
              "remoteOption": "option_1583391431329","filterable": true,"remoteOptions": [],"props": {"value": "measure","label": "measure"},"remoteFunc": this.getMeasure,"customClass": "","labelWidth": 100,"isLabelWidth": false,"hidden": false,"dataBind": true,"remoteSearch":true,
            },
            "name": "适用养护措施",
            "key": "适用养护措施",
            "model": "measure",
            "rules": [{required: false,message: "必须填写"}]
          },
          {
            "type": "select",
            "icon": "icon-select",
            "options": {
              "defaultValue": "","multiple": false,"disabled": false,"clearable": false,"placeholder": "请选择","required": false,"showLabel": false,"width": "250px","options": [],"remote": true,"remoteType": "option",
              "remoteOption": "option_1583391431329","filterable": true,"remoteOptions": [],"props": {"value": "name","label": "name"},"remoteFunc": this.getDiction,"customClass": "","labelWidth": 100,"isLabelWidth": false,"hidden": false,"dataBind": true,"remoteSearch":true,
            },
            "name": "适用公路等级",
            "key": "公路等级",
            "model": "highwayLevel",
            "rules": [{required: false,message: "必须填写"}]
          }
        ],
        config: {
          labelWidth: 100,
          labelPosition: "right",
          size: "medium",
          customClass: ""
        }
      },
      tableSet: {
        tableColumn: [
          {
            label: "适用养护措施",
            prop: "measure"
          },{
            label: "适用公路等级",
            prop: "highwayLevel"
          },{
            label: "AADT",
            prop: "aadt"
          },{
            label: "轻度破碎板",
            prop: "slightlyBrokenPlate"
          },{
            label: "重度破碎板",
            prop: "heavyCrushingPlate"
          },{
            label: "轻度裂缝",
            prop: "mildCrack"
          },{
            label: "中度裂缝",
            prop: "moderateCracks"
          },{
            label: "重度裂缝",
            prop: "severeCracks"
          },{
            label: "轻度板角断裂",
            prop: "mildPaFracture"
          },{
            label: "中度板角断裂",
            prop: "moderatePaFracture"
          },{
            label: "重度板角断裂",
            prop: "severePaFracture"
          },{
            label: "轻度错台",
            prop: "mildWrongStation"
          },{
            label: "重度错台",
            prop: "severeFaultTable"
          },{
            label: "拱起",
            prop: "hunchUp"
          },{
            label: "边角剥落",
            prop: "cornerSpalling"
          },{
            label: "轻度接缝料损坏",
            prop: "slightJmDamage"
          },{
            label: "重度接缝料损坏",
            prop: "heavyJmDamage"
          },{
            label: "potHole",
            prop: "坑洞"
          },{
            label: "唧泥",
            prop: "pumpingMud"
          },{
            label: "露骨",
            prop: "bareSurface"
          },{
            label: "修补",
            prop: "mending"
          },{
            label: "备注",
            prop: "remark"
          }
        ],
        tableColBtn: [
          {
            show: true,
            size: "mini",
            type: "primary",
            plain: true,
            round: false,
            circle: false,
            loading: false,
            disabled: false,
            icon: "el-icon-view",
            title: "查看",
            name: "查看",
            click: this.rowClick
          },
          {
            show: true,
            size: "mini",
            type: "primary",
            plain: true,
            round: false,
            circle: false,
            loading: false,
            disabled: false,
            icon: "el-icon-edit",
            title: "编辑",
            name: "编辑",
            click: this.edit
          },
          {
          show: true,
          size:'mini',
          type:'danger',
          plain: true,
          round: false,
          circle: false,
          loading: false,
          disabled: false,
          icon:'el-icon-delete',
          title:'删除',
          name:'删除',
          click: this.del
        }
        ]
      },
      tableData: [],
      pageIndex: 1,
      pageSize: 10,
      pageCount: 0,
      form: {
        rowCode :0,/// 主键  int
        slightlyBrokenPlate :'0',/// 轻度破碎板
        heavyCrushingPlate :'0',/// 重度破碎板
        mildCrack :'0',/// 轻度裂缝
        moderateCracks :'0',/// 中度裂缝
        severeCracks :'0',/// 重度裂缝
        mildPaFracture :'0',/// 轻度板角断裂
        moderatePaFracture :'0',/// 中度板角断裂
        severePaFracture :'0',/// 重度板角断裂
        mildWrongStation :'0',/// 轻度错台
        severeFaultTable :'0',/// 重度错台
        hunchUp :'0',/// 拱起
        cornerSpalling :'0',/// 边角剥落
        slightJmDamage :'0',/// 轻度接缝料损坏
        heavyJmDamage :'0',/// 重度接缝料损坏
        potHole :'0',/// 坑洞
        pumpingMud :'0',/// 唧泥
        bareSurface :'0',/// 露骨
        mending :'0',/// 修补
        measure :'',/// 适用养护措施
        highwayLevel :[],/// 适用公路等级
        aadt :'',/// AADT
        remark :'',
        createUser :'',
        createUserName :'',
        createTime :'',
        updateUser :'',
        updateUserName :'',
        updateTime :'',
        status :'',
        r1 :'',
        r2 :'',
        r3 :'',
        r4 :'',
        r5 :'',
      },
      formConfig: {
        list: [
          {
            "type": "select",
            "icon": "icon-select",
            "options": {
              "defaultValue": "","multiple": false,"disabled": false,"clearable": false,"placeholder": "请选择","required": true,"showLabel": false,"width": "250px","options": [],"remote": true,"remoteType": "option",
              "remoteOption": "option_1583391431329","filterable": true,"remoteOptions": [],"props": {"value": "measure","label": "measure"},"remoteFunc": this.getMeasure,"customClass": "","labelWidth": 100,"isLabelWidth": false,"hidden": false,"dataBind": true,"remoteSearch":true,
            },
            "name": "适用养护措施",
            "key": "适用养护措施",
            "model": "measure",
            "rules": [{required: true,message: "必须填写"}]
          },
          {
            "type": "select",
            "icon": "icon-select",
            "options": {
              "defaultValue": "","multiple": true,"disabled": false,"clearable": false,"placeholder": "请选择","required": true,"showLabel": false,"width": "250px","options": [],"remote": true,"remoteType": "option",
              "remoteOption": "option_1583391431329","filterable": true,"remoteOptions": [],"props": {"value": "name","label": "name"},"remoteFunc": this.getDiction,"customClass": "","labelWidth": 100,"isLabelWidth": false,"hidden": false,"dataBind": true,"remoteSearch":true,
            },
            "name": "适用公路等级",
            "key": "公路等级",
            "model": "highwayLevel",
            "rules": [{required: true,message: "必须填写"}]
          },
          {
            type: "input",
            icon: "icon-input",
            options: {
              width: "100%",defaultValue: "",required: false,dataType: "string",pattern: "",placeholder: "",customClass: "",disabled: false,labelWidth: 100,isLabelWidth: false,hidden: false,dataBind: true,showPassword: false,remoteFunc: "func_1573044806373"
            },
            name: "AADT",
            novalid: {},
            key: "aadt",
            model: "aadt",
            rules: [{type: "string",message: "格式不正确"}]
          },
          {
            type: "radio",
            icon: "icon-radio-active",
            options: {inline: true,defaultValue: "0",showLabel: true,options: [{value: "0",label: "否"},{value: "1",label: "是"}],required: false,
            width: "",remote: false,remoteOptions: [],props: {value: "value",label: "label"},remoteFunc: "func_1573044947832",customClass: "",
            labelWidth: 100,isLabelWidth: false,hidden: false,dataBind: true,disabled: false
            },
            name: "轻度破碎板",
            novalid: {},
            key: "slightlyBrokenPlate",
            model: "slightlyBrokenPlate",
            rules: []
          },
          {
            type: "radio",
            icon: "icon-radio-active",
            options: {inline: true,defaultValue: "0",showLabel: true,options: [{value: "0",label: "否"},{value: "1",label: "是"}],required: false,
            width: "",remote: false,remoteOptions: [],props: {value: "value",label: "label"},remoteFunc: "func_1573044947832",customClass: "",
            labelWidth: 100,isLabelWidth: false,hidden: false,dataBind: true,disabled: false
            },
            name: "重度破碎板",
            novalid: {},
            key: "heavyCrushingPlate",
            model: "heavyCrushingPlate",
            rules: []
          },
          {
            type: "radio",
            icon: "icon-radio-active",
            options: {inline: true,defaultValue: "0",showLabel: true,options: [{value: "0",label: "否"},{value: "1",label: "是"}],required: false,
            width: "",remote: false,remoteOptions: [],props: {value: "value",label: "label"},remoteFunc: "func_1573044947832",customClass: "",
            labelWidth: 100,isLabelWidth: false,hidden: false,dataBind: true,disabled: false
            },
            name: "轻度裂缝",
            novalid: {},
            key: "mildCrack",
            model: "mildCrack",
            rules: []
          },
          {
            type: "radio",
            icon: "icon-radio-active",
            options: {inline: true,defaultValue: "0",showLabel: true,options: [{value: "0",label: "否"},{value: "1",label: "是"}],required: false,
            width: "",remote: false,remoteOptions: [],props: {value: "value",label: "label"},remoteFunc: "func_1573044947832",customClass: "",
            labelWidth: 100,isLabelWidth: false,hidden: false,dataBind: true,disabled: false
            },
            name: "中度裂缝",
            novalid: {},
            key: "moderateCracks",
            model: "moderateCracks",
            rules: []
          },
          {
            type: "radio",
            icon: "icon-radio-active",
            options: {inline: true,defaultValue: "0",showLabel: true,options: [{value: "0",label: "否"},{value: "1",label: "是"}],required: false,
            width: "",remote: false,remoteOptions: [],props: {value: "value",label: "label"},remoteFunc: "func_1573044947832",customClass: "",
            labelWidth: 100,isLabelWidth: false,hidden: false,dataBind: true,disabled: false
            },
            name: "重度裂缝",
            novalid: {},
            key: "severeCracks",
            model: "severeCracks",
            rules: []
          },
          {
            type: "radio",
            icon: "icon-radio-active",
            options: {inline: true,defaultValue: "0",showLabel: true,options: [{value: "0",label: "否"},{value: "1",label: "是"}],required: false,
            width: "",remote: false,remoteOptions: [],props: {value: "value",label: "label"},remoteFunc: "func_1573044947832",customClass: "",
            labelWidth: 100,isLabelWidth: false,hidden: false,dataBind: true,disabled: false
            },
            name: "轻度板角断裂",
            novalid: {},
            key: "mildPaFracture",
            model: "mildPaFracture",
            rules: []
          },
          {
            type: "radio",
            icon: "icon-radio-active",
            options: {inline: true,defaultValue: "0",showLabel: true,options: [{value: "0",label: "否"},{value: "1",label: "是"}],required: false,
            width: "",remote: false,remoteOptions: [],props: {value: "value",label: "label"},remoteFunc: "func_1573044947832",customClass: "",
            labelWidth: 100,isLabelWidth: false,hidden: false,dataBind: true,disabled: false
            },
            name: "中度板角断裂",
            novalid: {},
            key: "moderatePaFracture",
            model: "moderatePaFracture",
            rules: []
          },
          {
            type: "radio",
            icon: "icon-radio-active",
            options: {inline: true,defaultValue: "0",showLabel: true,options: [{value: "0",label: "否"},{value: "1",label: "是"}],required: false,
            width: "",remote: false,remoteOptions: [],props: {value: "value",label: "label"},remoteFunc: "func_1573044947832",customClass: "",
            labelWidth: 100,isLabelWidth: false,hidden: false,dataBind: true,disabled: false
            },
            name: "重度板角断裂",
            novalid: {},
            key: "severePaFracture",
            model: "severePaFracture",
            rules: []
          },
          {
            type: "radio",
            icon: "icon-radio-active",
            options: {inline: true,defaultValue: "0",showLabel: true,options: [{value: "0",label: "否"},{value: "1",label: "是"}],required: false,
            width: "",remote: false,remoteOptions: [],props: {value: "value",label: "label"},remoteFunc: "func_1573044947832",customClass: "",
            labelWidth: 100,isLabelWidth: false,hidden: false,dataBind: true,disabled: false
            },
            name: "轻度错台",
            novalid: {},
            key: "mildWrongStation",
            model: "mildWrongStation",
            rules: []
          },
          {
            type: "radio",
            icon: "icon-radio-active",
            options: {inline: true,defaultValue: "0",showLabel: true,options: [{value: "0",label: "否"},{value: "1",label: "是"}],required: false,
            width: "",remote: false,remoteOptions: [],props: {value: "value",label: "label"},remoteFunc: "func_1573044947832",customClass: "",
            labelWidth: 100,isLabelWidth: false,hidden: false,dataBind: true,disabled: false
            },
            name: "重度错台",
            novalid: {},
            key: "severeFaultTable",
            model: "severeFaultTable",
            rules: []
          },
          {
            type: "radio",
            icon: "icon-radio-active",
            options: {inline: true,defaultValue: "0",showLabel: true,options: [{value: "0",label: "否"},{value: "1",label: "是"}],required: false,
            width: "",remote: false,remoteOptions: [],props: {value: "value",label: "label"},remoteFunc: "func_1573044947832",customClass: "",
            labelWidth: 100,isLabelWidth: false,hidden: false,dataBind: true,disabled: false
            },
            name: "拱起",
            novalid: {},
            key: "hunchUp",
            model: "hunchUp",
            rules: []
          },
          {
            type: "radio",
            icon: "icon-radio-active",
            options: {inline: true,defaultValue: "0",showLabel: true,options: [{value: "0",label: "否"},{value: "1",label: "是"}],required: false,
            width: "",remote: false,remoteOptions: [],props: {value: "value",label: "label"},remoteFunc: "func_1573044947832",customClass: "",
            labelWidth: 100,isLabelWidth: false,hidden: false,dataBind: true,disabled: false
            },
            name: "边角剥落",
            novalid: {},
            key: "cornerSpalling",
            model: "cornerSpalling",
            rules: []
          },
          {
            type: "radio",
            icon: "icon-radio-active",
            options: {inline: true,defaultValue: "0",showLabel: true,options: [{value: "0",label: "否"},{value: "1",label: "是"}],required: false,
            width: "",remote: false,remoteOptions: [],props: {value: "value",label: "label"},remoteFunc: "func_1573044947832",customClass: "",
            labelWidth: 100,isLabelWidth: false,hidden: false,dataBind: true,disabled: false
            },
            name: "轻度接缝料损坏",
            novalid: {},
            key: "slightJmDamage",
            model: "slightJmDamage",
            rules: []
          },
          {
            type: "radio",
            icon: "icon-radio-active",
            options: {inline: true,defaultValue: "0",showLabel: true,options: [{value: "0",label: "否"},{value: "1",label: "是"}],required: false,
            width: "",remote: false,remoteOptions: [],props: {value: "value",label: "label"},remoteFunc: "func_1573044947832",customClass: "",
            labelWidth: 100,isLabelWidth: false,hidden: false,dataBind: true,disabled: false
            },
            name: "重度接缝料损坏",
            novalid: {},
            key: "heavyJmDamage",
            model: "heavyJmDamage",
            rules: []
          },
          {
            type: "radio",
            icon: "icon-radio-active",
            options: {inline: true,defaultValue: "0",showLabel: true,options: [{value: "0",label: "否"},{value: "1",label: "是"}],required: false,
            width: "",remote: false,remoteOptions: [],props: {value: "value",label: "label"},remoteFunc: "func_1573044947832",customClass: "",
            labelWidth: 100,isLabelWidth: false,hidden: false,dataBind: true,disabled: false
            },
            name: "坑洞",
            novalid: {},
            key: "potHole",
            model: "potHole",
            rules: []
          },
          {
            type: "radio",
            icon: "icon-radio-active",
            options: {inline: true,defaultValue: "0",showLabel: true,options: [{value: "0",label: "否"},{value: "1",label: "是"}],required: false,
            width: "",remote: false,remoteOptions: [],props: {value: "value",label: "label"},remoteFunc: "func_1573044947832",customClass: "",
            labelWidth: 100,isLabelWidth: false,hidden: false,dataBind: true,disabled: false
            },
            name: "唧泥",
            novalid: {},
            key: "pumpingMud",
            model: "pumpingMud",
            rules: []
          },
          {
            type: "radio",
            icon: "icon-radio-active",
            options: {inline: true,defaultValue: "0",showLabel: true,options: [{value: "0",label: "否"},{value: "1",label: "是"}],required: false,
            width: "",remote: false,remoteOptions: [],props: {value: "value",label: "label"},remoteFunc: "func_1573044947832",customClass: "",
            labelWidth: 100,isLabelWidth: false,hidden: false,dataBind: true,disabled: false
            },
            name: "露骨",
            novalid: {},
            key: "bareSurface",
            model: "bareSurface",
            rules: []
          },
          {
            type: "radio",
            icon: "icon-radio-active",
            options: {inline: true,defaultValue: "0",showLabel: true,options: [{value: "0",label: "否"},{value: "1",label: "是"}],required: false,
            width: "",remote: false,remoteOptions: [],props: {value: "value",label: "label"},remoteFunc: "func_1573044947832",customClass: "",
            labelWidth: 100,isLabelWidth: false,hidden: false,dataBind: true,disabled: false
            },
            name: "修补",
            novalid: {},
            key: "mending",
            model: "mending",
            rules: []
          },
          {
            "type": "textarea",
            "icon": "icon-diy-com-textarea",
            "options": {
              "width": "500px","defaultValue": "","required": false,"disabled": false,"pattern": "","placeholder": "","customClass": "",
              "labelWidth": 100,"isLabelWidth": false,"hidden": false,"dataBind": true,"remoteFunc": "func_1577068006527","remoteOption": "option_1577068006527"
            },
            "name": "备注",
            "key": "1577068006527",
            "model": "remark",
            "rules": []
          }
        ],
        config: {
          labelWidth: 100,
          labelPosition: "right",
          size: "medium",
          customClass: ""
        }
      },
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
  },
  //方法集合
  methods: {
    /********字典获取 ******/
    getDiction(target, targets) {
      let name = target.form.key;
      this.$http.post(this.$url.getDict, { search: name }).then(res => {
          let { data } = res;
          target.setList(data);
      });
    },
    getMeasure(target, targets){
      this.$http.post(this.$url.routeDecision.getpmmeasurefs, { pageSize: 9999999,pageIndex:1 }).then(res => {
          let { data } = res;
          target.setList(data);
      });
    },
    setHighwayLevel(row){
      if (row.highwayLevel) {
        if(row.highwayLevel.indexOf(',')>=0){this.form.highwayLevel = row.highwayLevel.split(",")
        }else if(row.highwayLevel.indexOf('，')>=0){this.form.highwayLevel = row.highwayLevel.split("，")
        }else{this.form.highwayLevel = [row.highwayLevel];}
      }else{ this.form.highwayLevel = []; }
    },
    /*******获取表格数据*****/
    getTableData() {//获取表格数据
        let that = this;
        this.$http.postHandle('',this.$url.routeDecision.getcementmeasures, { ...that.searchForm, pageIndex:this.pageIndex, pageSize:this.pageSize }).then(res => {
            this.tableData = res.data;
            this.pageCount = res.pageCount;
        });
    },
    addRow() {//新增
      this.showTabFom = true;
      this.operationType = 1;
      this.resetForm("form");
    },
    searchTable(){//查询
      this.pageIndex = 1;
      this.pageSize = pageSize;
      this.getTableData();
    },
    goPageIndex(pageIndex,pageSize) {//分页
      this.pageIndex = pageIndex;
      this.pageSize = pageSize
      this.getTableData();
    },
    rowClick(row) {//查看
        this.operationType = 3;
        this.form = this.$formSetForm(this.form,row);
        this.setHighwayLevel(row);
        this.showTabFom = true;
    },
    edit(row, index) {//编辑
        this.operationType = 2;
        this.form = this.$formSetForm(this.form,row);
        this.setHighwayLevel(row);
        this.showTabFom = true;
    },
    del(row, index) {//删除
      let form = row;
      this.$msgDel(this.$url.routeDecision.operationcementmeasure, { cementMeasure: form, operationType: 8 }).then(res => {
        if((this.tableData.length<=1)&&(this.pageIndex>1)){
          this.pageIndex=this.pageIndex-1;
        }
        this.getTableData();
      });
    },
    dataSubmit() {//保存
        this.$refs.form.submit().then(res => {
            let form = this.$formSetForm(this.form, this.form);
            form.highwayLevel = this.form.highwayLevel.join(",");
            this.$http.postHandle("保存", this.$url.routeDecision.operationcementmeasure, { cementMeasure: form, operationType: this.operationType }).then(res => {
                this.showTabFom = false;
                this.getTableData();
            });
        });
    },
    close() {//返回
      this.$closePage(this.operationType).then(() => {
        this.showTabFom = false;
        this.getTableData();
      });
    },
    resetForm(formName) {//重置
      let that = this;
      this.form = this.$formSetForm(this.initializeForm , this.initializeForm)
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getTableData();
    this.initializeForm = this.$formSetForm(this.form , this.form)
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {}
};
</script>
<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/views/decision/PavementMaintenancePlanningCustomization/PreventiveMaintenanceDic/cxCementmeasures.vue"
}
</vue-filename-injector>
